export function isFileObject(value: unknown): boolean {
	return value instanceof File;
}

export function isValidUrl(value: string): boolean {
	try {
		new URL(value);
		return true;
	} catch {
		return false;
	}
}